//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"

export default function QuestionOptionEntrySmall({ option }) {
  return <div className={myStyles.questionOptionEntrySmall}>{option.text}</div>
}
